import { styled, Box, TableCell } from "@mui/material";

export const TechDataTableRoot = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "900px",
  margin: "auto",
  padding: "2rem 1rem",
  color: theme?.palette?.companyColors?.secondary,
}));

export const HeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme?.palette?.companyColors?.accent,
  color: theme?.palette?.companyColors?.secondary,
  border: `1px solid ${theme?.palette?.companyColors?.secondary}`,
  fontWeight: 600,
  fontSize: "1.25rem",
  [theme.breakpoints.up("xl")]: {
    fontSize: "1.5rem",
  },
}));

export const BodyCell = styled(TableCell)(({ theme }) => ({
  border: `1px solid ${theme?.palette?.companyColors?.secondary}`,
  color: theme?.palette?.companyColors?.secondary,
  fontSize: "1.25rem",
  [theme.breakpoints.up("xl")]: {
    fontSize: "1.5rem",
  },
}));
